import { useEffect } from 'react';

/**
 * Warns the user via the browser's native beforeunload dialog when there are
 * unsaved changes and they try to close/refresh the tab or navigate away.
 *
 * Also blocks the browser back/forward buttons via a soft popstate guard.
 *
 * Usage: useUnsavedChangesWarning(hasChanges);
 *
 * NOTE: In-app navigation (React Router <Link>, navigate()) still requires
 * an explicit window.confirm in the corresponding onClick handler if you want
 * to prompt the user. Use the exported `confirmDiscard` helper for that.
 */
export const useUnsavedChangesWarning = (hasUnsavedChanges) => {
  useEffect(() => {
    if (!hasUnsavedChanges) return undefined;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      // Legacy browsers require returnValue to be set to a non-empty string
      e.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);
};

/**
 * Standard confirmation dialog used across the app for discarding unsaved changes.
 * Returns true if the user chooses to leave, false if they want to stay.
 */
export const confirmDiscard = (message) => {
  return window.confirm(
    message || '¿Salir sin guardar los cambios?\n\nSe perderán los datos ingresados en este formulario.'
  );
};
